import { Capabilities, castAs } from "@goodgamestudios/createjs-utilities";
import { getLogger } from "@goodgamestudios/logger";
import { int } from "@goodgamestudios/math-utilities";
import { IEnvironmentGlobals } from "../../basic/IEnvironmentGlobals";
import { ClientFunnelTrackingEvent } from "./ClientFunnelTrackingEvent";
import { EnvGlobalsHandler } from "../../basic/EnvGlobalsHandler";
import { SessionTypes } from "../../constants/SessionTypes";
import { TrackingEventIds } from "../constants/TrackingEventIds";
import { TrackingCache } from "../TrackingCache";
import { ClientFunnelGameStates } from "./ClientFunnelGameStates";
import { ClientFunnelPlayTimeController } from "./ClientFunnelPlayTimeController";
import { BasicModel } from "../../basic/model/BasicModel";

import Stage = createjs.Stage;

const logger = getLogger("Tracking.ClientFunnelTrackingController");
export class ClientFunnelTrackingController {
    constructor(private env: IEnvironmentGlobals) {
        let event: ClientFunnelTrackingEvent = new ClientFunnelTrackingEvent(this.env.referrer);

        event.client_version = this.env.buildNumberGame;
        event.device_language_code = Capabilities.language;
        event.account_hash = this.env.accountId;
        event.session_count = int(this.env.accountCookie.sessionCount);
        event.website_id = parseInt(this.env.urlVariables.extendedWebsiteID);
        event.media_partner_id = parseInt(this.env.campainVars.extendedPartnerID);

        let sessionTypeName: string;
        switch (this.env.accountCookie.sessionType) {
            case SessionTypes.FIRST_SESSION:
                sessionTypeName = "FIRST_SESSION";
                break;
            case SessionTypes.FIRST_SESSION_AFTER_UPDATE:
                sessionTypeName = "FIRST_SESSION_AFTER_UPDATE";
                break;
            case SessionTypes.REGULAR_SESSION:
                sessionTypeName = "REGULAR_SESSION";
                break;
            default:
                sessionTypeName = "REGULAR_SESSION";
                break;
        }
        event.session_type_name = sessionTypeName;

        TrackingCache.getInstance().cacheEvent(TrackingEventIds.CLIENT_FUNNEL, event);
    }

    private static instance: ClientFunnelTrackingController;

    public static getInstance(): ClientFunnelTrackingController {
        if (!ClientFunnelTrackingController.instance) {
            ClientFunnelTrackingController.instance = new ClientFunnelTrackingController(EnvGlobalsHandler.globals);
        }
        return ClientFunnelTrackingController.instance;
    }


    public set stage(value: Stage) {

        if (!this._playTimeController) {
            this._playTimeController = new ClientFunnelPlayTimeController(value, this.trackState);
        }

    }


    public dispose() {
        if (this._playTimeController) this._playTimeController.dispose();
    }
    private _playTimeController: ClientFunnelPlayTimeController;

    public trackState(gamestate_name: string): void {
        try {
            const trackingEvent: ClientFunnelTrackingEvent = castAs<ClientFunnelTrackingEvent>(TrackingCache.getInstance().getEvent(TrackingEventIds.CLIENT_FUNNEL), "ClientFunnelTrackingEvent");

            if (!trackingEvent) {
                logger.warn("ClientFunnelTrackingevent couldn't be found (TODO HTML5)"); // TODO: @HTML5 - investigate
                return;
            }

            if (ClientFunnelGameStates.FIRST_SESSION_ONLY.indexOf(gamestate_name) > -1) {
                if (trackingEvent.session_count === 1) {
                    return;
                }
            }

            trackingEvent.gamestate_name = gamestate_name;
            TrackingCache.getInstance().sendEvent(TrackingEventIds.CLIENT_FUNNEL);

            logger.debug("CLIENT FUNNEL TRACKING STEP: " + gamestate_name);

            if (gamestate_name === ClientFunnelGameStates.GAME_PLAYABLE) {
                this._playTimeController.start();
            }
        } catch (e) {
            // catch all errors
            logger.error(`ClientFunnelTrackingController.trackState: Error tracking event "${gamestate_name}"`)
        }
    }
}

